import { Link } from "react-router-dom";
import config from "../../config";
import React from "react";

export default function NewsItem({ post, lang, index }) {
  const redmoreBtn = {
    en: "Read More",
    ru: "Читать далее",
    hy: "Կարդալ ավելին",
  };
  return (
    <div className="news-item position-relative">
      <img
        src={
          post.uploads ? `${config.api.API_URL}/${post?.uploads[0]?.path}` : ""
        }
        width="100%"
        alt=""
      />
      <div className="row details no-gutters align-items-center">
        <div className="col-6 col-md-8">
          <h6>{post?.title && post?.title[lang]}</h6>
        </div>
        <div className="col-6 col-md-4 text-right">
          <Link to={`${config.api.blogPost}/${post._id}`}>
            <button className="round white-outline" aria-label="round white outline">{redmoreBtn[lang]}</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
